import brgI18n from '@/locales';
const i18n = brgI18n.global;
const lc = 'views.cash_auto_deduct_group_setting.option_setting_table.';
const cashAutoDeductScheduleTypeCode = [
    'EVERYDAY',
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY',
    'EVERY_1TH',
    'EVERY_5TH',
    'EVERY_10TH',
    'EVERY_15TH',
    'EVERY_20TH',
    'EVERY_25TH',
    'EVERY_LASTDAY',
];
const result = {};
cashAutoDeductScheduleTypeCode.forEach((code, index) => {
    result[code] = {
        text: i18n.t(`${lc}schedule_type_code_text[${index}]`),
        value: code,
    };
});
// 라이더 관리 > 자동차감그룹 설정 > 스케줄 항목 - 시간
export default result;
